import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
    before: {
        backgroundColor: theme.palette.pageNavigationBar.main,
    },
    root: {
        position: 'relative',
        padding: '0 0 100%',
        '&.MuiListItem-root.Mui-selected': {
            backgroundColor: theme.palette.pageNavigationBar.dark,
        },
    },
    wrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
    },
    icon: {
        minWidth: 'unset',
        color: theme.palette.primary.contrastText,
        '& .MuiSvgIcon-root': {
            [theme.breakpoints.up('xl')]: {
                fontSize: '1.75rem',
            },
        },
    },
}));

interface Props {
    selected: boolean;
    onClickHandler: () => void;
    children: React.ReactElement;
}

export default function NavListButton({ selected, onClickHandler, children }: Props) {
    const { classes } = useStyles();

    return (
        <div className={classes.before}>
            <ListItem
                button
                onClick={onClickHandler}
                selected={selected}
                disableGutters
                className={classes.root}
            >
                <div className={classes.wrapper}>
                    <ListItemIcon className={classes.icon}>{children}</ListItemIcon>
                </div>
            </ListItem>
        </div>
    );
}
